import { Link, Stack, TrashIcon } from "@workflows/ui";
import * as React from "react";
import { useDeleteAnonymousAttachment } from "./hooks/useDeleteAnonymousAttachment";
interface AnonymousAttachmentsDeleteProps {
  attachment: any;
  code: string;
  refId: string;
}
export function AnonymousAttachmentsDelete({
  attachment,
  code,
  refId
}: AnonymousAttachmentsDeleteProps): JSX.Element {
  const {
    deleteAnonymousAttachment
  } = useDeleteAnonymousAttachment();
  const handleClick = () => {
    deleteAnonymousAttachment({
      input: {
        attachmentId: attachment.id,
        code,
        refId
      },
      onError(error) {
        console.error(error);
      },
      onCompleted({
        deleteAnonymousAttachment
      }) {
        if (deleteAnonymousAttachment?.errors && deleteAnonymousAttachment?.errors.length > 0) {
          console.error(deleteAnonymousAttachment.errors);
        }
      }
    });
  };
  return <Stack direction={"horizontal"}>
      <Link onClick={handleClick}>
        <TrashIcon />
      </Link>
    </Stack>;
}